import { Component, OnInit, ViewChild } from '@angular/core';
import { RequestReponse } from '../../requets/shared/model/request-reponse.model';
import { Request } from '../../requets/shared/model/request.model';
import { StudentService } from '../../students/shared/student.service';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { Location } from '@angular/common';
import { HistoryStudentDialogComponent } from 'src/app/core/modal/history-student-dialog/history-student-dialog.component';
import { ActivatedRoute } from '@angular/router';
import { RequestEndorse } from '../shared/request-endorse.model';
import { Program } from '../../programs/shared/program.model';
import { Faculty } from '../../programs/shared/faculty.model';
import { RequestEndorseSubject } from '../shared/request-endorse-subject.model';
import { EndorsesService } from '../shared/endorses.service';
import { SavedEndorseComponent } from '../endorse-detail-subject/saved-endorse/saved-endorse.component';
import { EndorseDetailSubjectComponent } from '../endorse-detail-subject/endorse-detail-subject.component';
import { Endorse } from '../shared/endorse.model';
import { RequestService } from '../../requets/shared/request.service';
import { DetailRequest } from '../../requets/shared/model/detail-request.model';
import { College } from '../../requets/shared/model/college.model';
import { RequestRecogniseSubject } from '../shared/request-recognise-subject.model';
import { Evaluator } from '../shared/evaluator.model';
import { ConfirmationDialogComponent } from 'src/app/core/modal/confirmation-dialog/confirmation-dialog.component';


@Component({
  selector: 'app-endorse-detail',
  templateUrl: './endorse-detail.component.html',
  styleUrls: ['./endorse-detail.component.scss']
})
export class EndorseDetailComponent implements OnInit {
  request: RequestReponse;
  isPifle: boolean;
  cedulaEvaluador: String;
  nombreEvaluador: String;
  requestEndorse: RequestEndorse;
  subjects: RequestEndorseSubject[];
  subjectsTest: DetailRequest[];
  subjectRecon: RequestRecogniseSubject[];
  evaluators: Evaluator[];
  enableCheck = false;
  messageError = '';
  messageSucces = '';
  enabledSpinner = false;
  interval;
  timeLeft = 4;
  colleges: College[];

  @ViewChild(EndorseDetailSubjectComponent) endorseDetailSubjectComponent: EndorseDetailSubjectComponent;

  constructor( private dialog: MatDialog,
    private route: ActivatedRoute,
    private location: Location,
    private endorsesService: EndorsesService,
    private requestService: RequestService,
    private studentService: StudentService) { }

  ngOnInit() {
    this.route.queryParams.subscribe(
      (params) => {
        this.requestEndorse = JSON.parse(params['request']) as RequestEndorse;
        this.fillInfoInit(this.requestEndorse);
        this.isPifle = this.requestEndorse.tipo === 'PRUEBA LENGUA EXTRANJERA';
        if (this.isPifle) {
          this.getDetailRquestTest();
          this.getDetailRecon();
        } else {
          this.getRequestDetail();
        }
      }
    );
  }

  back() {
    this.location.back();
    if (this.interval !== undefined) {
      clearInterval(this.interval);
     }
  }
  savedEndorse() {
    this.interval = 0;
    this.messageError = '';
    let yesEndoerses = [];
    let noEndoerses = [];
    if (!this.isPifle) {
      yesEndoerses =  this.endorseDetailSubjectComponent.requets.filter(
        (subject: RequestEndorseSubject) => subject.aval === 'S'
      );
       noEndoerses =  this.endorseDetailSubjectComponent.requets.filter(
        (subject: RequestEndorseSubject) => subject.aval === 'N'
      );
      this.generateEndorse(yesEndoerses, noEndoerses);
    } else {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data =  { tittle: 'Mensaje Confirmación', message: '¿Desea avalar el reconocimiento?'};
      dialogConfig.width = '40%';
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(value => {
        if (value === 1) {
          yesEndoerses =  this.buildRequestEndorseSubject('S');
        } else {
          noEndoerses =  this.buildRequestEndorseSubject('N');
        }
        this.generateEndorsePifle(yesEndoerses, noEndoerses);
      });
    }
  }

  private buildRequestEndorseSubject(aval): RequestEndorseSubject[] {
    const request = this.subjectRecon.map(
      (subject ) => {
        const subje = new RequestEndorseSubject();
        subje.solicitud = subject.id.solicitud;
        subje.consecutivo = subject.id.consecutivo;
        subje.codigoMateria = '';
        subje.nombreMateria = subject.comentarioEvaluador;
        subje.codigoMateriaReconocida = subject.materiaBean.materia;
        subje.nombreMateriaReconocida = subject.materiaBean.nombrelargo;
        subje.aval = aval;
        subje.semestre = subject.semestre + '';
        return subje;
      }
    );
    return request;
  }

  private generateEndorse(yesEndoerses, noEndoerses) {
    if (yesEndoerses.length > 0 || noEndoerses.length > 0) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data =  { noEndoerses : noEndoerses , yesEndoerses: yesEndoerses};
      dialogConfig.width = '70%';
      const dialogRef = this.dialog.open(SavedEndorseComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(
        (data: Endorse) => {
          if (data !== null) {

            data.materias = data.materias.map(
              (subject) => {
                subject.solicitud = this.requestEndorse.codigo;
                return subject;
              }
            );
            this.enabledSpinner = true;
            const dialogConfigC = new MatDialogConfig();
            dialogConfigC.data =  { tittle: 'Mensaje Confirmación',
            message: '¿Esta seguro que desea Guardar los avales dados a la solicitud?'};
            dialogConfigC.width = '40%';
            const dialogRefC = this.dialog.open(ConfirmationDialogComponent, dialogConfigC);
            dialogRefC.afterClosed().subscribe(value => {
              if (value === 1) {
                this.endorsesService.sendEndorse(data).subscribe(
                  (result) => {
                    this.enabledSpinner = false;
                    if (result.data) {
                      if (result.data.length > 0) {
                        this.messageError = result.data;
                      } else {
                        this.messageSucces  = 'Se guardaron correctamente los avales de la solicitud';
                        // this.back();
                        this.startTimerSuccess();
                      }
                    } else {
                      this.messageSucces  = 'Se guardaron correctamente los avales de la solicitud';
                      // this.back();
                      this.startTimerSuccess();
                    }
                  }
                  );
              }
            });
          }
        }
      );
    } else {
      this.messageError = 'Por lo menos una de las materias debe tener un aval distinto a "Pendiente"  ';
      this.startTimerError();
    }
  }

  private generateEndorsePifle(yesEndoerses, noEndoerses) {
    if (yesEndoerses.length > 0 || noEndoerses.length > 0) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data =  { noEndoerses : noEndoerses , yesEndoerses: yesEndoerses};
      dialogConfig.width = '70%';
      const dialogRef = this.dialog.open(SavedEndorseComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(
        (data: Endorse) => {
          if (data !== null) {

            data.materias = data.materias.map(
              (subject) => {
                subject.solicitud = this.requestEndorse.codigo;
                return subject;
              }
            );
            this.enabledSpinner = true;
            this.endorsesService.sendEndorse(data).subscribe(
              (result) => {
                this.enabledSpinner = false;
                  if (result.data) {
                    if (result.data.length > 0) {
                        this.messageError = result.data;
                    } else {
                      this.messageSucces  = 'Se guardaron correctamente los avales de la solicitud';
                      // this.back();
                      this.startTimerSuccess();
                    }
                  } else {
                    this.messageSucces  = 'Se guardaron correctamente los avales de la solicitud';
                    // this.back();
                    this.startTimerSuccess();
                  }
              }
            );
          }
        }
      );
    } else {
      this.messageError = 'Por lo menos una de las materias debe tener un aval distinto a "Pendiente"  ';
      this.startTimerError();
    }
  }

  showHistory() {
    this.studentService.getStudentRecords(this.request.solicitud.cedula , this.request.programa.codigo, true).subscribe(
      (result) => {
        if (result.data) {
          const dialogConfig = new MatDialogConfig();
          dialogConfig.data =  { semestres: result.data.semestres.sort() , historia: result.data.historia,
                                  cedula: this.request.solicitud.cedula , nombre : this.request.nombreEstudiante,
                                  programa: this.request.programa.nombre};
          dialogConfig.width = '70%';
          this.dialog.open(HistoryStudentDialogComponent, dialogConfig);
        }
      }
    );
  }
  private fillInfoInit(requestEndorse: RequestEndorse) {
    this.request = new RequestReponse();
    const solicitud = new Request();
    const programa = new Program();
    const facultad = new Faculty();
    solicitud.solicitud = requestEndorse.codigo;
    const cedula = requestEndorse.estudiante.split(' ')[0];
    solicitud.cedula = cedula;
    this.request.nombreEstudiante = requestEndorse.estudiante.substring(cedula.length).trim();
    const codPrograma = requestEndorse.programa.split(' ')[0];
    programa.codigo = parseInt(codPrograma , 10);
    programa.nombre = requestEndorse.programa.substring(codPrograma.length).trim();
    programa.version = requestEndorse.version;
    const fecha = requestEndorse.fecha.split('/');
    solicitud.fecha  = new Date(parseInt(fecha[2], 10), parseInt(fecha[1], 10) - 1, parseInt(fecha[0], 10));
    this.request.solicitud = solicitud;
    const codFacultad = requestEndorse.facultad.split(' ')[0];
    facultad.codigo = codFacultad;
    facultad.nombre =  requestEndorse.facultad.substring(codFacultad.length).trim();
    programa.facultad =  facultad;
    this.request.programa = programa;
    this.isPifle = requestEndorse.tipo === 'PRUEBA LENGUA EXTRANJERA';
    const idEvaluador = requestEndorse.evaluador.split(' ')[0];
    this.cedulaEvaluador = idEvaluador;
    this.nombreEvaluador = requestEndorse.evaluador.substring(idEvaluador.length).trim();
  }

  private getRequestDetail() {
    this.enabledSpinner = true;
    this.endorsesService.getRequetsDetial(this.request.solicitud.solicitud).subscribe(
      (result) => {
        this.enabledSpinner = false;
          if (result.data) {
              this.subjects = result.data  as RequestEndorseSubject[];
              this.subjects.map(
                (subject) => {
                  subject.aval = !subject.aval ? 'P' : subject.aval;
                  return subject;
                }
              );
              if (this.subjects.length === 0) {
                this.back();
              }
          }
      }
    );
  }

  private getDetailRquestTest () {
    this.requestService.getDetailRequets(this.requestEndorse.codigo, 10, null, 'A').subscribe(
      (result) => {
          if (result.data) {
            if (result.data.length > 0) {
              this.enabledSpinner = false;
              this.subjectsTest = result.data as DetailRequest[];
            } else {
              this.back();
            }
          }
      }
    );
  }

  private getDetailRecon () {
    this.requestService.getEvaluatorRequest(this.requestEndorse.codigo).subscribe(
      (result) => {
          if (result.data) {
            this.evaluators = result.data as Evaluator[];
            this.getDetailReconSubject();
          }
      }
    );
  }

  private getDetailReconSubject () {
    this.requestService.getReconRequest(this.requestEndorse.codigo).subscribe(
      (result) => {
          if (result.data) {
            this.subjectRecon = result.data as RequestRecogniseSubject[];
            this.subjectRecon = this.subjectRecon.map(
              (subject: RequestRecogniseSubject) => {
                const evalu = this.evaluators.find( evaluator => evaluator.consecutivo === subject.id.consecutivo );
                subject.evaluador = evalu.nombre;
                return subject;
              }
            );
          }
      }
    );
  }

  private startTimerError() {
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        if (this.messageError.length > 0) {
          this.messageError = '';
        }
      }
    }, 1000);
  }

  private startTimerSuccess() {
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
       this.back();
      }
    }, 1000);
  }



}
